import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  static availableCodes = {
    ca: () => 'ca',
    ua: () => 'ua',
    fr: () => 'fr',
    no: () => 'nb',
    nb: () => 'nb',
    en: () => 'en',
    de: () => 'de',
    cs: () => 'cs',
    es: () => 'es',
    ar: () => 'ar',
    pl: () => 'pl',
  };

  getLocaleId() {
    const userLang = navigator.language || (navigator as any).userLanguage;
    const code = userLang.split('-')[0];
    const foundCode = LocaleService.availableCodes[code];
    const returnCode = foundCode ? foundCode() : 'en';

    return returnCode;
  }
}
